import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05bdf700")

_pushScopeId("data-v-05bdf700")
const _hoisted_1 = {
  key: 0,
  class: "buttons-frame"
}
const _hoisted_2 = {
  key: 0,
  class: "button-frame"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("患者登録 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("患者一覧、編集 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("患者一覧 ")
const _hoisted_6 = {
  key: 1,
  class: "button-frame"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("予約一覧")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("登録・変更 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("予約一覧 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("営業時間編集 ")
const _hoisted_12 = {
  key: 2,
  class: "button-frame"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("カルテ閲覧、編集 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("カルテ閲覧 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("カルテ、問診")
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("データ作成 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("カルテ、問診")
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("データ閲覧 ")
const _hoisted_21 = { class: "button-frame" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("アカウント")
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("作成、編集、削除 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("システム設定 ")
const _hoisted_26 = { class: "button-frame" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("ログアウト ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("ログアウトしますか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_badge_frame = _resolveComponent("badge-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("div", null, _toDisplayString(_ctx.today), 1)
        ]),
        _: 1
      }),
      (!_ctx.entering)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_ctx.patientWrite || _ctx.calendarWrite)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  (_ctx.patientWrite)
                    ? (_openBlock(), _createBlock(_component_badge_frame, {
                        key: 0,
                        count: _ctx.patientAnswers.length
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_normal_button, {
                            class: "dashboard-button",
                            state: "normal-green",
                            large: true,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/patient`)))
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["count"]))
                    : _createCommentVNode("", true),
                  (_ctx.patientWrite)
                    ? (_openBlock(), _createBlock(_component_normal_button, {
                        key: 1,
                        class: "dashboard-button",
                        state: "normal",
                        large: true,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/patient_list`)))
                      }, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }))
                    : (_ctx.patientRead || _ctx.calendarWrite)
                      ? (_openBlock(), _createBlock(_component_normal_button, {
                          key: 2,
                          class: "dashboard-button",
                          state: "normal",
                          large: true,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/patient_list`)))
                        }, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.calendarWrite || _ctx.calendarRead)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_ctx.calendarWrite)
                    ? (_openBlock(), _createBlock(_component_normal_button, {
                        key: 0,
                        class: "dashboard-button",
                        state: "warning",
                        large: true,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/appointment?y=${_ctx.thisYear}&m=${_ctx.thisMonth}`)))
                      }, {
                        default: _withId(() => [
                          _hoisted_7,
                          _hoisted_8,
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.calendarRead)
                    ? (_openBlock(), _createBlock(_component_normal_button, {
                        key: 1,
                        class: "dashboard-button",
                        state: "warning",
                        large: true,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/appointment?y=${_ctx.thisYear}&m=${_ctx.thisMonth}`)))
                      }, {
                        default: _withId(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.acceptAppointment)
                    ? (_openBlock(), _createBlock(_component_normal_button, {
                        key: 2,
                        class: "dashboard-button",
                        state: "normal-gray",
                        large: true,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/business_hour?y=${_ctx.thisYear}&m=${_ctx.thisMonth}`)))
                      }, {
                        default: _withId(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.patientWrite || _ctx.patientRead || _ctx.dataWrite || _ctx.dataRead)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  (_ctx.patientWrite)
                    ? (_openBlock(), _createBlock(_component_normal_button, {
                        key: 0,
                        class: "dashboard-button",
                        state: "normal",
                        large: true,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_menu`)))
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }))
                    : (_ctx.patientRead)
                      ? (_openBlock(), _createBlock(_component_normal_button, {
                          key: 1,
                          class: "dashboard-button",
                          state: "normal",
                          large: true,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_menu`)))
                        }, {
                          default: _withId(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                  (_ctx.dataWrite)
                    ? (_openBlock(), _createBlock(_component_normal_button, {
                        key: 2,
                        class: "dashboard-button",
                        state: "normal-gray",
                        large: true,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_data_menu`)))
                      }, {
                        default: _withId(() => [
                          _hoisted_15,
                          _hoisted_16,
                          _hoisted_17
                        ]),
                        _: 1
                      }))
                    : (_ctx.dataRead)
                      ? (_openBlock(), _createBlock(_component_normal_button, {
                          key: 3,
                          class: "dashboard-button",
                          state: "normal-gray",
                          large: true,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_data_menu`)))
                        }, {
                          default: _withId(() => [
                            _hoisted_18,
                            _hoisted_19,
                            _hoisted_20
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_21, [
              (_ctx.accountWrite || _ctx.clinicOwner)
                ? (_openBlock(), _createBlock(_component_normal_button, {
                    key: 0,
                    class: "dashboard-button",
                    state: "normal-gray",
                    large: true,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/account_list`)))
                  }, {
                    default: _withId(() => [
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.settingWrite || _ctx.clinicOwner)
                ? (_openBlock(), _createBlock(_component_normal_button, {
                    key: 1,
                    class: "dashboard-button",
                    state: "normal-gray",
                    large: true,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/setting`)))
                  }, {
                    default: _withId(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_normal_button, {
                class: "dashboard-button",
                state: "delete",
                large: true,
                onClick: _ctx.onLogout
              }, {
                default: _withId(() => [
                  _hoisted_27
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_28
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})